import * as React from "react";
import CreatableComponent from "../../../ui/create/CreatableComponent";
import Phone from "../../../../model/phone/Phone";

export default class PhoneNumberMultiSelector extends CreatableComponent<Phone> {

	elementToText(phone: Phone) {
		return phone.nationalPhoneNumber;
	}
}
